class AnnonceCreationUtils {
  //region steps
  fastAnnonceMaxStep(annonce) {
    return (annonce && this.isAnnonceToValidate(annonce)) ? 4 : 7;
  }

  completeAnnonceMaxStep(annonce) {
    return (annonce && this.isAnnonceToValidate(annonce)) ? 7 : 10;
  }

  stepsToIgnoreInEdit() {
    return ['RECAP', 'PAYMENT_SUMMARY', 'ADDITIONNAL_REWARD']
  }

  steps() {
    return {
      'ONBOARDING': {
        fastStep: 0,
        compStep: 0,
      },
      'VEHICLE_TYPE': {
        fastStep: 1,
        compStep: 1,
      },
      'BRAND': {
        fastStep: 2,
        compStep: 2,
      },
      'MODEL': {
        fastStep: 3,
        compStep: 3,
      },
      'MANDATORY_FIELDS': {
        fastStep: 4,
        compStep: 4,
      },
      'ADDITIONNAL_FIELDS': {
        fastStep: null,
        compStep: 5,
      },
      'PHOTOS': {
        fastStep: null,
        compStep: 6,
      },
      'PAPERS': {
        fastStep: null,
        compStep: 7,
      },
      'ADDITIONNAL_REWARD': {
        fastStep: 5,
        compStep: 8,
      },
      'RECAP': {
        fastStep: 6,
        compStep: 9,
      },
      'PAYMENT_SUMMARY': {
        fastStep: 7,
        compStep: 10,
      },
    }
  }

  stepFields() {
    return {
      VEHICLE_TYPE: ['vehicleType'],
      BRAND: ['brand'],
      MODEL: ['model'],
      MANDATORY_FIELDS: [
        'licensePlate', 'licensePlateConfirm', 'vin', 'bicycode', 'serialNumber',
        'energy', 'color', 'address', 'isProprio', 'identityRecto', 'identityVerso',
        'firstnameOwner', 'lastnameOwner'
      ],
      ADDITIONNAL_FIELDS: [
        'vin', 'annonceDescription', 'hasWindowEngraving', 'fiscalPower', 'finitions'
      ],
      PHOTOS: ['vehicleFiles', 'imagesVehicleState', 'vehicleDescription'],
      PAPERS: ['carteGriseFile', 'insuranceCompany', 'insuranceContract', 'plainteFile'],
      ADDITIONNAL_REWARD: ['additionnalRewardAmount', 'additionnalRewardLevel']
    };
  }

  //endregion

  licensedAnnoncePrice() {
    return 300;
  }

  unlicensedAnnoncePrice() {
    return 150;
  }

  getAnnonceTotalPrice(annonce) {
    const rewardAmount = annonce.additionnalRewardAmount.value != null ? annonce.additionnalRewardAmount.value : 0;
    if (annonce.isLicensed) {
      return rewardAmount + this.licensedAnnoncePrice();
    } else {
      return rewardAmount + this.unlicensedAnnoncePrice();
    }
  }


  isAnnonceToValidate(annonce) {
    return annonce && annonce.hasOwnProperty('status') && annonce.status && annonce.status.hasOwnProperty('value') && annonce.status.value === 'TO_VALIDATE'
  }
}

export default new AnnonceCreationUtils()



// WEBPACK FOOTER //
// ./src/utils/AnnonceCreationUtils.js